import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import { LinkIcon } from '../Icons/index.js';
import { gold, darkGreyOpacity } from '../../assets/colors.js';
import { Montserrat } from '../../assets/fonts.js';

var _templateObject, _templateObject2;
var Action = styled.a.attrs(function (props) {
  return {
    href: props.to
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var MenuList = (function (_ref) {
  var options = _ref.options,
    comp = _ref.comp;
  var Links = comp && options.external ? comp : Action;
  var LinksStyled = styled(Links)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background: transparent;\n    margin-top: 5px;\n    display: block;\n    width: 100%;\n    white-space: nowrap;\n    text-decoration: none;\n    color: ", ";\n    font-family: ", ";\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 18px;\n    text-shadow: 0 2px 4px 0 ", ";\n    :hover {\n      color: white;\n    }\n  "])), gold, Montserrat, darkGreyOpacity);
  return options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(LinksStyled, {
      key: option.id,
      to: option.to,
      color: option.color,
      target: option.target
    }, option.label, /*#__PURE__*/React__default.createElement(LinkIcon, null));
  });
});

export { Action, MenuList as default };
